export const sources = {
    GOOGLE_REVIEWS: 'Google reviews',
};
